<template>
    <div>
        <DCard
            padding
        >
            <AdvancedSearchForm
                :countries="countries"
                :brands="brands"
                :original-brands="originalBrands"
                :titles="titles"
                :customer-types="customerTypes"
                :payment-terms="paymentTerms"
                :payment-methods="paymentMethods"
                :tax-exemptions="taxExemptions"
                :billing-types="billingTypes"
                :customer="customer"
                :customer-segments="customerSegments"
                :errors="errors"
                :status-options="statusOptions"
                :invoice-delivery-types="invoiceDeliveryTypes"
                :languages="languages"
                :communication-subscriptions-types="communicationSubscriptionsTypes"
                :market-regions="marketRegions"
                @search="doSearch"
            />
        </DCard>
    </div>
</template>

<script>
import AdvancedSearchForm, { defaultFieldValues } from '~@/Components/Customers/Customers/AdvancedSearchForm.vue'
export default {
    name: 'CustomerSearchIndex',
    components: { AdvancedSearchForm },
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        countries: {
            type: Array,
            default: () => { return [] }
        },
        brands: {
            type: Array,
            default: () => { return [] }
        },
        originalBrands: {
            type: Array,
            default: () => { return [] }
        },
        titles: {
            type: Array,
            default: () => { return [] }
        },
        customerTypes: {
            type: Array,
            default: () => { return [] }
        },
        paymentTerms: {
            type: Array,
            default: () => { return [] }
        },
        paymentMethods: {
            type: Array,
            default: () => { return [] }
        },
        taxExemptions: {
            type: Array,
            default: () => { return [] }
        },
        billingTypes: {
            type: Array,
            default: () => { return [] }
        },
        customer: {
            type: Object,
            default: () => { return {} }
        },
        stickyNotes: {
            type: Array,
            default: () => { return [] }
        },
        customerSegments: {
            type: Array,
            default: () => { return [] }
        },
        statusOptions: {
            type: Array,
            default: () => { return [] }
        },
        invoiceDeliveryTypes: {
            type: Array,
            default: () => { return [] }
        },
        languages: {
            type: Array,
            default: () => { return [] }
        },
        communicationSubscriptionsTypes: {
            type: Array,
            default: () => { return [] }
        },
        marketRegions: {
            type: Array,
            default: () => { return [] }
        }
    },
    methods: {
        doSearch (form) {
            const searchfields = {}
            for (const field in defaultFieldValues) {
                if (form[field] !== null && form[field] !== []) {
                    searchfields[field] = form[field]
                }
            }
            this.$inertia.get(this.$route('customers.customers.advanced-search.show', searchfields))
        }
    }
}
</script>
